/* Mossify cart drawer — replaces UpCart. Body is the Liquid section `mz-cart`, re-rendered via the Section Rendering API. */
(function () {
  var root = document.getElementById('mz-cart');
  if (!root) return;
  var panel = root.querySelector('[data-mzc-panel]');
  var cfg = window.mzSettings || {};
  var ROOT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTIONS = ['mz-cart', 'cart-icon-bubble'];
  var seq = 0, busy = 0, queue = Promise.resolve(), lastRender = 0, lastFocus = null, prevPct = null, prevDone = null;
  var nativeFetch = window.fetch.bind(window);
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/<[^>]*>/g, '');
  }
  function thresholds() {
    var r = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
    var ship = cfg.freeShipping || 9900, gift = cfg.freeGift || 15000;
    if (cfg.freeShippingInShopCurrency) ship = Math.round(ship * r);
    if (cfg.freeGiftInShopCurrency) gift = Math.round(gift * r);
    return { ship: ship, gift: gift };
  }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem('mzc:' + k); if (v === null) sessionStorage.removeItem('mzc:' + k); else sessionStorage.setItem('mzc:' + k, v); } catch (e) { return null; } }
  function track(name, extra) { var o = { event: name }; for (var k in extra || {}) o[k] = extra[k]; (window.dataLayer = window.dataLayer || []).push(o); }

  function api(path, body) {
    var my = ++seq;
    return nativeFetch(ROOT_URL.replace(/\/$/, '') + path, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Mz-Cart': '1' },
      body: JSON.stringify(Object.assign({ sections: SECTIONS, sections_url: location.pathname }, body))
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; if (my !== seq) j.sections = null; return j; }); });
  }
  function run(fn) { busy++; root.classList.add('is-busy'); queue = queue.then(fn).catch(showError).then(function () { if (--busy === 0) root.classList.remove('is-busy'); }); return queue; }
  function showError(e) {
    var msg = (e && (e.description || e.message)) || 'Something went wrong. Please try again.';
    var t = root.querySelector('[data-mzc-toast]');
    t.textContent = msg; t.hidden = false; clearTimeout(t._h); t._h = setTimeout(function () { t.hidden = true; }, 4000);
    return refresh();
  }

  function paint(sections) {
    if (!sections) return;
    if (sections['cart-icon-bubble']) {
      var b = document.getElementById('cart-icon-bubble');
      var d = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (b && d) b.innerHTML = d.innerHTML;
    }
    if (!sections['mz-cart']) return;
    var doc = new DOMParser().parseFromString(sections['mz-cart'], 'text/html');
    var fresh = doc.querySelector('[data-mzc-inner]');
    var old = panel.querySelector('[data-mzc-inner]');
    if (!fresh) return;
    var up = old && old.querySelector('[data-mzc-uptrack]');
    var upX = up ? up.scrollLeft : 0;
    var body = old && old.querySelector('[data-mzc-body]');
    var bodyY = body ? body.scrollTop : 0;
    var note = old && old.querySelector('[data-mzc-note]');
    var noteFocus = note && document.activeElement === note;
    var oldKeys = old ? [].map.call(old.querySelectorAll('[data-key]'), function (l) { return l.dataset.key; }) : null;
    var oldTotal = old && old.querySelector('[data-mzc-total]');
    var oldCents = oldTotal ? +oldTotal.dataset.cents : null;
    var oldCount = old ? +old.dataset.count : null;
    if (old) old.parentNode.replaceChild(fresh, old); else panel.appendChild(fresh);
    if (oldKeys) fresh.querySelectorAll('[data-key]').forEach(function (l) { if (oldKeys.indexOf(l.dataset.key) < 0) l.classList.add('is-new'); });
    var nt = fresh.querySelector('[data-mzc-total]');
    if (nt && oldCents !== null && oldCents !== +nt.dataset.cents) countUp(nt, oldCents, +nt.dataset.cents);
    if (oldCount !== null && +fresh.dataset.count > oldCount) bounce();
    var nu = fresh.querySelector('[data-mzc-uptrack]'); if (nu) nu.scrollLeft = upX;
    var nb = fresh.querySelector('[data-mzc-body]'); if (nb) nb.scrollTop = bodyY;
    if (noteFocus) { var nn = fresh.querySelector('[data-mzc-note]'); nn.focus(); nn.setSelectionRange(nn.value.length, nn.value.length); }
    lastRender = Date.now();
    rewards(fresh);
    arrows(fresh);
    syncGift(fresh);
    document.dispatchEvent(new CustomEvent('mz:cart:updated', { detail: { count: +fresh.dataset.count } }));
  }

  function countUp(el, from, to) {
    if (reduce) return;
    var t0 = performance.now(), d = 450;
    el.classList.add('is-ticking');
    (function step(t) {
      var k = Math.min(1, (t - t0) / d), e = 1 - Math.pow(1 - k, 3);
      el.textContent = money(Math.round(from + (to - from) * e));
      if (k < 1) requestAnimationFrame(step); else el.classList.remove('is-ticking');
    })(t0);
  }
  function bounce() {
    var b = document.getElementById('cart-icon-bubble');
    if (!b || reduce) return;
    b.classList.remove('mzc-bounce'); void b.offsetWidth; b.classList.add('mzc-bounce');
  }

  function openSheet(kind) {
    var tpl = root.querySelector('template[data-mzc-' + kind + ']');
    if (!tpl) return false;
    closeSheet(true);
    var w = document.createElement('div');
    w.className = 'mzc__sheet mzc__sheet--' + kind;
    w.appendChild(tpl.content.cloneNode(true));
    panel.appendChild(w);
    requestAnimationFrame(function () { w.classList.add('is-open'); });
    var bx = w.querySelector('.mzc__sheet-box'); if (bx) { bx.setAttribute('tabindex', '-1'); bx.focus({ preventScroll: true }); }
    track('mz_cart_' + kind + '_view');
    if (kind === 'gifts') confetti(w.querySelector('.mzc__sheet-box'));
    return true;
  }
  function sheet() {
    if (!cfg.cartClearance || ss('clearShown') || !root.querySelector('template[data-mzc-clear]')) return false;
    ss('clearShown', '1');
    return openSheet('clear');
  }
  function confetti(box) {
    if (!box || reduce) return;
    var bits = ['🎉', '🌿', '✨', '🎁', '💚'];
    for (var i = 0; i < 18; i++) {
      var s = document.createElement('span');
      s.className = 'mzc__leaf';
      s.textContent = bits[i % bits.length];
      s.style.left = (10 + Math.random() * 80) + '%'; s.style.top = '30px';
      s.style.setProperty('--dx', (Math.random() * 120 - 60) + 'px');
      s.style.setProperty('--dy', (-30 - Math.random() * 70) + 'px');
      s.style.setProperty('--r', (Math.random() * 360 - 180) + 'deg');
      s.style.animationDelay = (200 + Math.random() * 200) + 'ms';
      box.appendChild(s); setTimeout(s.remove.bind(s), 1700);
    }
  }
  function closeSheet(now) {
    var w = panel.querySelector('.mzc__sheet');
    if (!w) return;
    if (now === true) return w.remove();
    w.classList.remove('is-open');
    setTimeout(function () { w.remove(); }, 300);
  }
  function checkout() {
    var f = root.querySelector('.mzc__checkout-form');
    var btn = f && f.querySelector('.mzc__checkout');
    if (btn) { btn.classList.add('is-going'); btn.disabled = true; }
    track('mz_cart_checkout');
    var note = root.querySelector('[data-mzc-note]');
    var go = function () { location.href = ROOT_URL + 'checkout'; };
    if (!note) return go();
    nativeFetch(ROOT_URL + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }).then(go, go);
  }

  function refresh() {
    var my = ++seq;
    return nativeFetch(ROOT_URL + '?sections=' + SECTIONS.join(',') + '&_=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); }).then(function (j) { if (my === seq) paint(j); }).catch(function () {});
  }

  // One source of truth for the gift tier: 'claimed' (gift line is $0), 'open' (can claim now), 'code' (shopper's own code
  // doesn't combine with it), 'none' (nothing to offer), 'below' (under the threshold). The bar's gift check = claimed or open.
  function giftState(inner) {
    var total = +inner.dataset.giftBasis || 0, count = +inner.dataset.count;
    if (!(total >= thresholds().gift && count > 0)) return 'below';
    if (inner.dataset.giftKey) return inner.dataset.giftFree === 'true' ? 'claimed' : 'open';
    if (ss('giftHold') === String(count)) return inner.dataset.hasCode === 'true' ? 'code' : 'none';
    return cfg.cartGiftPicker && root.querySelector('template[data-mzc-gifts]') ? 'open' : 'none';
  }
  function rewards(inner) {
    var t = thresholds(), ship = +inner.dataset.basis || 0, total = +inner.dataset.giftBasis || 0, g = giftState(inner);
    var msg = inner.querySelector('[data-mzc-msg]'), fill = inner.querySelector('[data-mzc-fill]');
    var html, gift = g === 'claimed' || g === 'open';
    if (ship < t.ship) html = 'Add <strong class="mzc__amt">' + money(t.ship - ship) + '</strong> for free shipping!';
    else if (g === 'below') html = 'Add <strong class="mzc__amt">' + money(t.gift - total) + '</strong> to get a free gift! 🎉';
    else if (g === 'claimed') html = 'Free gift added! 🎉';
    else if (g === 'open') html = 'Free gift unlocked! 🎁';
    else if (g === 'code') html = 'Your code replaces the free gift.';
    else html = 'Free shipping unlocked! 🎉';
    msg.innerHTML = html;
    var shipPos = (t.ship / t.gift) * 100;
    inner.querySelector('[data-mzc-tier="ship"]').style.left = shipPos + '%';
    var pct = Math.min(gift ? 100 : 96, (Math.max(ship, total) / t.gift) * 100);
    if (prevPct !== null && !reduce) { fill.style.transition = 'none'; fill.style.width = prevPct + '%'; fill.offsetWidth; fill.style.transition = ''; }
    fill.style.width = pct + '%';
    var done = (ship >= t.ship ? 1 : 0) + (gift ? 1 : 0);
    inner.querySelector('[data-mzc-tier="ship"]').classList.toggle('is-done', ship >= t.ship);
    inner.querySelector('[data-mzc-tier="gift"]').classList.toggle('is-done', gift);
    if (prevDone !== null && done > prevDone) celebrate(inner.querySelector('[data-mzc-tier="' + (done === 2 ? 'gift' : 'ship') + '"]'), done);
    prevPct = pct; prevDone = done;
  }

  function celebrate(tier, level) {
    track('mz_cart_milestone', { mz_milestone: level === 2 ? 'free_gift' : 'free_shipping' });
    if (!tier || reduce) return;
    tier.classList.add('is-pop');
    setTimeout(function () { tier.classList.remove('is-pop'); }, 900);
    var box = root.querySelector('[data-mzc-rewards]');
    if (!box) return;
    var leaves = ['🌿', '🍃', '✨', '💚'];
    for (var i = 0; i < 16; i++) {
      var s = document.createElement('span');
      s.className = 'mzc__leaf';
      s.textContent = leaves[i % leaves.length];
      s.style.left = (tier.offsetLeft + 10) + 'px';
      s.style.setProperty('--dx', (Math.random() * 160 - 80) + 'px');
      s.style.setProperty('--dy', (-40 - Math.random() * 60) + 'px');
      s.style.setProperty('--r', (Math.random() * 360 - 180) + 'deg');
      s.style.animationDelay = (Math.random() * 120) + 'ms';
      box.appendChild(s);
      setTimeout(s.remove.bind(s), 1300);
    }
  }

  var MANAGED = /^(CLEAR\d+|PICK\d+)/i;
  function codes(inner) {
    return (inner.dataset.codes || '').split(',').filter(Boolean).map(function (x) { var p = x.split(':'); return { code: p[0], ok: p[1] === '1' }; });
  }
  function syncGift(inner) {
    var key = inner.dataset.giftKey, qty = +inner.dataset.giftQty || 0, total = +inner.dataset.giftBasis || +inner.dataset.basis || 0;
    var count = +inner.dataset.count, free = inner.dataset.giftFree === 'true';
    // The claimed gift is made $0 by its hidden FREEGIFT- product code (one unit off that product); the $150 gate is ours. Shopify is
    // the judge: a claimed gift that isn't $0 (code rejected, same product also bought) is removed, not charged. No gift line = no code.
    var reached = total >= thresholds().gift && count > 0;
    if (!key && (ss('giftCode') || inner.dataset.giftCode)) {
      ss('giftCode', null);
      return run(function () { return setGiftCode(null).then(function (r) { if (r && r.sections) paint(r.sections); }); });
    }
    if (key && reached && !free && qty === 1) {
      if (ss('giftCode') && ss('giftTry') !== key) {
        ss('giftTry', key);
        return run(function () { return setGiftCode(ss('giftCode')).then(function (r) { if (r && r.sections) paint(r.sections); }); });
      }
      if (inner.dataset.hasCode === 'true') ss('giftHold', String(count));
      ss('giftCode', null); ss('giftTry', null);
      return run(function () { return api('/cart/change.js', { id: key, quantity: 0 }).then(function () { return setGiftCode(null); }).then(function (r) { if (r && r.sections) paint(r.sections); }); });
    }
    if (key && !reached && inner.dataset.hasCode !== 'true') ss('giftHold', String(count));
    if (count === 0 && inner.dataset.protKey) {
      return run(function () { return api('/cart/change.js', { id: inner.dataset.protKey, quantity: 0 }).then(function (r) { paint(r.sections); }); });
    }
    if (key && (!reached || qty > 1)) {
      return run(function () { return api('/cart/change.js', { id: key, quantity: reached ? 1 : 0 }).then(function (r) { paint(r.sections); }); });
    }
    var cs = codes(inner), stale = cs.filter(function (c) { return !c.ok && MANAGED.test(c.code); });
    if (stale.length) {
      var keep = cs.filter(function (c) { return stale.indexOf(c) < 0; }).map(function (c) { return c.code; });
      return run(function () { return api('/cart/update.js', { discount: keep.join(',') }).then(function (r) { paint(r.sections); }); });
    }
    var cta = inner.querySelector('.mzc__giftcta');
    var canPick = !key && giftState(inner) === 'open';
    if (cta) cta.hidden = !canPick;
    if (canPick && root.classList.contains('is-open') && !ss('giftAsked') && !panel.querySelector('.mzc__sheet')) {
      ss('giftAsked', '1');
      setTimeout(function () { openSheet('gifts'); }, 700);
    }
  }
  function shownCodes() {
    var c = [].map.call(root.querySelectorAll('[data-mzc-uncode]'), function (b) { return b.dataset.mzcUncode; });
    var g = panel.querySelector('[data-mzc-inner]').dataset.giftCode || ss('giftCode');
    if (g && panel.querySelector('[data-mzc-inner]').dataset.giftKey) c.push(g);
    return c;
  }
  function setGiftCode(code) {
    return nativeFetch(ROOT_URL + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (x) { return x.json(); }).then(function (c) {
      var have = (c.discount_codes || []).map(function (d) { return d.code; });
      var keep = have.filter(function (h) { return !/^(FREE)?GIFT-/i.test(h); });
      if (code) keep.push(code);
      if (keep.join(',') === have.join(',')) return null;
      return api('/cart/update.js', { discount: keep.join(',') });
    });
  }
  function addCode(code) {
    return nativeFetch(ROOT_URL + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (x) { return x.json(); }).then(function (c) {
      var have = (c.discount_codes || []).map(function (d) { return d.code; });
      if (have.some(function (h) { return h.toLowerCase() === code.toLowerCase(); })) return null;
      return api('/cart/update.js', { discount: have.concat(code).join(',') });
    });
  }


  function arrows(inner) {
    var tr = inner.querySelector('[data-mzc-uptrack]');
    if (!tr) return;
    function upd() {
      var p = inner.querySelector('[data-mzc-scroll="-1"]'), n = inner.querySelector('[data-mzc-scroll="1"]');
      if (p) p.disabled = tr.scrollLeft < 4;
      if (n) n.disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4;
    }
    tr.addEventListener('scroll', upd, { passive: true }); upd();
    if (window.ResizeObserver) new ResizeObserver(function () { upd(); if (tr.clientWidth && !tr.dataset.mzWoke) { tr.dataset.mzWoke = 1; tr.scrollLeft = 1; tr.scrollLeft = 0; } }).observe(tr);
  }

  var lockedY = null, vp = document.querySelector('meta[name="viewport"]'), vp0 = vp && vp.content;
  function noPinch(e) { e.preventDefault(); }
  function lockZoom(on) {
    if (vp) vp.content = on ? vp0 + ',maximum-scale=1,user-scalable=no' : vp0;
    document[on ? 'addEventListener' : 'removeEventListener']('gesturestart', noPinch);
  }
  function lockPage(on) {
    var b = document.body, h = document.documentElement;
    lockZoom(on);
    if (on && lockedY === null) {
      lockedY = window.scrollY;
      h.classList.add('mzc-lock');
      b.style.position = 'fixed'; b.style.top = -lockedY + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%';
    } else if (!on && lockedY !== null) {
      var y = lockedY; lockedY = null;
      h.classList.remove('mzc-lock');
      b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = '';
      h.style.scrollBehavior = 'auto'; window.scrollTo(0, y); h.style.scrollBehavior = '';
    }
  }
  function extras(on, quiet) {
    root.classList.toggle('mzc--extras-open', on);
    if (on && !quiet && !reduce) { root.classList.remove('mzc--extras-bounce'); void root.offsetWidth; root.classList.add('mzc--extras-bounce'); }
    var g = root.querySelector('[data-mzc-grab]'); if (g) g.setAttribute('aria-expanded', on);
    try { sessionStorage.setItem('mzcExtras', on ? '1' : '0'); } catch (e) {}
  }
  (function () {
    var s = null; try { s = sessionStorage.getItem('mzcExtras'); } catch (e) {}
    extras(s ? s === '1' : !window.matchMedia('(max-width: 749px)').matches, true);
    var y0 = null, done = false;
    root.addEventListener('touchstart', function (e) {
      var w = e.target.closest('.mzc__extras-wrap');
      y0 = w && !e.target.closest('input, textarea, select') ? e.touches[0].clientY : null; done = false;
    }, { passive: true });
    root.addEventListener('touchmove', function (e) {
      if (y0 === null || done) return;
      var dy = e.touches[0].clientY - y0;
      if (dy > 18) { done = true; extras(false); } else if (dy < -18) { done = true; extras(true); }
    }, { passive: true });
    root.addEventListener('touchcancel', function () { y0 = null; }, { passive: true });
  })();
  function open(opener) {
    lastFocus = opener || document.activeElement;
    root.hidden = false;
    root.classList.remove('is-entering'); void root.offsetWidth; root.classList.add('is-entering');
    setTimeout(function () { root.classList.remove('is-entering'); }, 900);
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    lockPage(true);
    root.classList.add('active');
    setTimeout(function () { var c = root.querySelector('[data-mzc-close]'); if (c) c.focus({ preventScroll: true }); }, 50);
    track('mz_cart_open');
  }
  function close() {
    root.classList.remove('is-open', 'active');
    lockPage(false);
    setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  var qtyTimers = {};
  function setQty(li, q) {
    var key = li.dataset.key;
    var input = li.querySelector('[data-mzc-input]');
    if (input) input.value = q;
    li.classList.toggle('is-removing', q === 0);
    if (input && q > 0 && !reduce) { input.classList.remove('is-bump'); void input.offsetWidth; input.classList.add('is-bump'); }
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      run(function () { return api('/cart/change.js', { id: key, quantity: q }).then(function (r) { paint(r.sections); }); });
      if (q === 0) track('mz_cart_remove');
    }, q === 0 ? (reduce ? 0 : 260) : 350);
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-mzc-sheet-close]')) return closeSheet();
    if (t.closest('[data-mzc-giftpick]')) return openSheet('gifts');
    var ga = t.closest('[data-mzc-giftadd]');
    if (ga) {
      var gv = +ga.closest('.mzc__up').querySelector('[data-mzc-upvar]').value;
      var gcode = ga.closest('.mzc__up').dataset.mzcGiftcode;
      var cur = panel.querySelector('[data-mzc-inner]').dataset.giftKey;
      ga.disabled = true; ga.classList.add('is-loading'); ga.textContent = 'Adding…';
      track('mz_cart_gift_pick', { mz_variant: gv });
      ss('giftCode', gcode); ss('giftTry', null);
      return run(function () {
        var p = cur ? api('/cart/change.js', { id: cur, quantity: 0 }) : Promise.resolve();
        var added;
        return p.then(function () { return api('/cart/add.js', { items: [{ id: gv, quantity: 1, properties: { _mz_gift: '1' } }] }); }).then(function (r) {
          added = r;
          return setGiftCode(gcode);
        }).then(function (u) {
          ga.classList.remove('is-loading'); ga.classList.add('is-added'); ga.textContent = 'Yours ✓';
          setTimeout(closeSheet, 450);
          paint((u && u.sections) || added.sections);
        });
      });
    }
    if (t.closest('[data-mzc-continue]')) return checkout();
    if (t.closest('[data-mzc-close]') || t === root.querySelector('[data-mzc-overlay]')) return close();
    var step = t.closest('[data-mzc-step]');
    if (step) {
      var li = step.closest('[data-key]'), inp = li.querySelector('[data-mzc-input]');
      return setQty(li, Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(step.dataset.mzcStep, 10)));
    }
    if (t.closest('[data-mzc-remove]')) return setQty(t.closest('[data-key]'), 0);
    var sc = t.closest('[data-mzc-scroll]');
    if (sc) {
      var tr = root.querySelector('[data-mzc-uptrack]'), cards = tr.children, step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : tr.clientWidth;
      var i = Math.round(tr.scrollLeft / step) + parseInt(sc.dataset.mzcScroll, 10);
      return tr.scrollTo({ left: Math.max(0, i) * step, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (t.closest('[data-mzc-grab]')) return extras(!root.classList.contains('mzc--extras-open'));
    var add = t.closest('[data-mzc-upadd]');
    if (add) {
      var tile = add.closest('.mzc__up');
      var vid = tile.querySelector('[data-mzc-upvar]').value;
      var inSheet = !!add.closest('.mzc__sheet');
      add.disabled = true; add.classList.add('is-loading'); add.textContent = 'Adding…';
      track(inSheet ? 'mz_cart_clearance_add' : 'mz_cart_upsell_add', { mz_variant: vid });
      return run(function () {
        var code = tile.dataset.code;
        return api('/cart/add.js', { items: [{ id: +vid, quantity: 1 }] }).then(function (r) {
          return code ? addCode(code).then(function (u) { if (u && u.sections) r.sections = u.sections; return r; }) : r;
        }).then(function (r) {
          add.classList.remove('is-loading'); add.classList.add('is-added'); add.textContent = 'Added ✓';
          tile.classList.add('is-added');
          return new Promise(function (res) { setTimeout(res, inSheet ? 0 : 450); }).then(function () { paint(r.sections); });
        });
      });
    }
    var un = t.closest('[data-mzc-uncode]');
    if (un) {
      var keep = shownCodes().filter(function (c) { return c !== un.dataset.mzcUncode; });
      return run(function () { return api('/cart/update.js', { discount: keep.join(',') }).then(function (r) { paint(r.sections); }); });
    }
  });

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-mzc-input]')) return setQty(t.closest('[data-key]'), Math.max(0, parseInt(t.value, 10) || 0));
    if (t.matches('[data-mzc-prot]')) {
      track('mz_cart_protection', { mz_on: t.checked });
      return run(function () {
        var p = t.checked ? api('/cart/add.js', { items: [{ id: +t.dataset.variant, quantity: 1 }] }) : api('/cart/change.js', { id: t.dataset.key, quantity: 0 });
        return p.then(function (r) { paint(r.sections); ss('protOff', t.checked ? null : '1'); });
      });
    }
  });

  var noteTimer;
  root.addEventListener('input', function (e) {
    if (!e.target.matches('[data-mzc-note]')) return;
    var v = e.target.value;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { nativeFetch(ROOT_URL + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) }); }, 500);
  });

  root.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-mzc-code]')) {
      e.preventDefault();
      var code = f.code.value.trim();
      if (!code) return;
      var have = shownCodes();
      track('mz_cart_discount', { mz_code: code });
      return run(function () {
        return api('/cart/update.js', { discount: have.concat(code).join(',') }).then(function (r) {
          paint(r.sections);
          var ok = (r.discount_codes || []).some(function (d) { return d.code.toLowerCase() === code.toLowerCase() && d.applicable; });
          var err = root.querySelector('[data-mzc-err]');
          if (!ok && err) { err.textContent = '“' + code + '” can’t be applied to this cart.'; err.hidden = false; }
        });
      });
    }
    if (f.matches('.mzc__checkout-form')) {
      e.preventDefault();
      clearTimeout(noteTimer);
      if (!sheet()) checkout();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('is-open')) return;
    if (e.key === 'Escape') return panel.querySelector('.mzc__sheet') ? closeSheet() : close();
    if (e.key !== 'Tab') return;
    var f = panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, summary');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  document.addEventListener('click', function (e) {
    var icon = e.target.closest('#cart-icon-bubble, a[href$="/cart"][data-mzc-open], [data-mzc-open]');
    if (!icon || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    refresh(); open(icon);
  }, true);

  /* Anything else that adds to the cart (Pumper tiers, Pole Finder, quick add, other apps) opens the drawer too. */
  var pending;
  function external(url, isAdd) {
    clearTimeout(pending);
    pending = setTimeout(function () {
      if (Date.now() - lastRender < 700) { if (isAdd && !root.classList.contains('is-open')) open(); return; }
      refresh().then(function () { if (isAdd && !root.classList.contains('is-open')) open(); });
    }, 120);
  }
  function watch(url, mine) {
    if (mine || typeof url !== 'string') return;
    var m = url.match(/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/);
    if (m) external(url, m[1] === 'add');
  }
  window.fetch = function (input, init) {
    var url = input && (input.url || input);
    var mine = init && init.headers && (init.headers['X-Mz-Cart'] || (init.headers.get && init.headers.get('X-Mz-Cart')));
    var p = nativeFetch(input, init);
    p.then(function (r) { if (r.ok) watch(String(url), mine); }).catch(function () {});
    return p;
  };
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    this.addEventListener('load', function () { if (this.status < 400) watch(String(url), false); });
    return xo.apply(this, arguments);
  };

  /* Dawn's product form looks for <cart-drawer>; this element answers it so the PDP add-to-cart renders straight into our drawer. */
  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class extends HTMLElement {
      getSectionsToRender() { return SECTIONS.map(function (id) { return { id: id }; }); }
      setActiveElement(el) { lastFocus = el; }
      renderContents(r) { seq++; paint(r && r.sections); open(lastFocus); }
      open(opener) { open(opener); }
      close() { close(); }
    });
  }

  window.mzCart = { open: function () { refresh(); open(); }, close: close, refresh: refresh };
  window.upcartOpenCart = window.mzCart.open;
  window.upcartCloseCart = close;
  window.upcartRefreshCart = refresh;

  var first = panel.querySelector('[data-mzc-inner]');
  if (first) { rewards(first); arrows(first); syncGift(first); }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  if (/[?&]cart=open/.test(location.search)) open();
})();
